import { render } from "./AccountDetailsAddressesTab.vue?vue&type=template&id=d89f1240"
import script from "./AccountDetailsAddressesTab.vue?vue&type=script&lang=js"
export * from "./AccountDetailsAddressesTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__